export const API_SERVICES = {
  AUTH_API: 'auth-api',
  PROVIDER_API: 'provider-api',
  MACROS_API: 'macros-api',
  APPOINTMENT_API: 'appointment-api',
  USER_MANAGEMENT_API: 'user-management-api',
  SSO_API: 'sso-api',
  EHR_API: 'ehr-api',
  TRANSCRIPT_API: 'transcript-api',
  GRAPHQL_API: 'graphql-api',
  GWP_API: 'gwp-api',
  SIGNUP_API: 'signup-api',
  TEXT_EXPANDER_API: 'text-expander-api',
};
